import React, { createContext, Dispatch, ReactElement, ReactNode, SetStateAction, useContext, useState } from 'react'

type VisibilityContextProps = {
  isVisible?: boolean
  setIsVisible?: Dispatch<SetStateAction<boolean>>
}

const VisibilityContext = createContext<VisibilityContextProps>({})

type VisibilityProviderProps = { children?: ReactNode }

export const VisibilityProvider = ({ children }: VisibilityProviderProps): ReactElement => {
  const [isVisible, setIsVisible] = useState(false)

  return <VisibilityContext.Provider value={{ isVisible, setIsVisible }}>{children}</VisibilityContext.Provider>
}

export const useVisibilityContext = (): VisibilityContextProps => {
  return useContext(VisibilityContext)
}
